export const MCP_PAGE_TEST_ID = 'developers_mcp';
export const MCP_TITLE_TEST_ID = 'developers_mcp_title-label';
export const MCP_HEADER_CREATE_TEST_ID = 'developers_mcp_create-btn';

export const MCP_GRID_TEST_ID = 'developers_mcp_grid';
export const MCP_CARD_TEST_ID = (uuid: string) =>
  `developers_mcp_card-row-${uuid}`;
export const MCP_CARD_NAME_TEST_ID = (uuid: string) =>
  `developers_mcp_card_name-label-${uuid}`;
export const MCP_CARD_PREVIEW_TEST_ID = (uuid: string) =>
  `developers_mcp_card_preview-label-${uuid}`;
export const MCP_CARD_STATUS_TEST_ID = (uuid: string) =>
  `developers_mcp_card_status-status-${uuid}`;
export const MCP_CARD_CREATED_TEST_ID = (uuid: string) =>
  `developers_mcp_card_created-row-${uuid}`;
export const MCP_CARD_EXPIRES_TEST_ID = (uuid: string) =>
  `developers_mcp_card_expires-row-${uuid}`;
export const MCP_CARD_REVOKE_TEST_ID = (uuid: string) =>
  `developers_mcp_card_revoke-btn-${uuid}`;

export const MCP_EMPTY_TEST_ID = 'developers_mcp_empty';
export const MCP_EMPTY_CTA_TEST_ID = 'developers_mcp_empty_create-btn';

export const MCP_LOADING_TEST_ID = 'developers_mcp_content-loading';
export const MCP_ERROR_TEST_ID = 'developers_mcp_content-error';

// "MCP" is the sanctioned placeholder copy pending the product copy decision
// tracked on PEGO-13911.
export const MCP_PAGE_TITLE = 'MCP tokens';
export const MCP_CREATE_BUTTON_LABEL = 'Create MCP token';
export const MCP_EMPTY_STATE_MESSAGE = 'No MCP tokens exist yet';
export const MCP_ERROR_MESSAGE =
  'Something went wrong loading your MCP tokens. Please try again.';

export const MCP_STATUS_LABELS = {
  active: 'Active',
  revoked: 'Revoked',
  expired: 'Expired'
} as const;

export const REVOKE_MCP_MODAL_TEST_ID = 'developers_mcp_revoke-modal';
export const REVOKE_MCP_CONFIRM_TEST_ID = 'developers_mcp_revoke_confirm-btn';
export const REVOKE_MCP_CANCEL_TEST_ID = 'developers_mcp_revoke_cancel-btn';

export const REVOKE_MCP_TITLE = 'Revoke MCP token';
export const REVOKE_MCP_CONFIRM_LABEL = 'Revoke token';
export const revokeMcpBody = (name: string) =>
  `Are you sure you want to revoke "${name}"? Anything using this token will immediately lose access. This cannot be undone.`;
export const revokeMcpSuccess = (name: string) =>
  `MCP token "${name}" was revoked`;
export const REVOKE_MCP_ERROR =
  'Something went wrong revoking the MCP token. Please try again.';
